<template>
  <section
    class="box has-border-light"
    :class="headerClass"
    :data-e2e="EstateCypressAttribute.standardPlan.views.VAULT_PLAN_BILLING_CARD"
  >
    <div class="p-5">
      <div class="custom-flex">
        <div class="p-r-5">
          <p
            class="has-text-weight-semibold is-size-1"
            :data-e2e="LightDiagnosticCypressAttribute.views.BILLING_PLAN_TITLE"
          >
            {{ billingPlan.computedName }}
          </p>
          <p class="has-text-weight-medium is-size-3">{{ billingPlan.subTitle }}</p>
        </div>
        <div class="is-flex-grow-1" />
        <div v-if="!hidePrice" class="m-r-20 m-l-20 has-text-right" :class="recommendedTextClass">
          <template v-if="billingPlan.showPrices">
            <template v-if="isPlanFree">
              <VaultFreePlanPriceView :billing-plan="billingPlan" />
            </template>
            <div v-else>
              <p
                class="m-l-10 has-text-weight-semibold is-size-1"
                :data-e2e="EstateCypressAttribute.standardPlan.views.PRICE"
              >
                {{ billingPlan.formattedFinalPrice }}
              </p>
              <p
                v-if="billingPlan.chargeRecurringFee"
                :data-e2e="EstateCypressAttribute.standardPlan.views.YEARLY_PRICE"
              >
                +{{ $t('standardplan.per-year', { price: billingPlan.formattedYearlyPrice }) }}
              </p>
            </div>
          </template>
        </div>
        <slot v-if="hasCallToAction" name="button">
          <ButtonView
            class="has-text-weight-semibold m-t-6"
            :class="buttonClass"
            outlined
            @click="onClick"
            :data-e2e="EstateCypressAttribute.standardPlan.buttons.SELECT_STANDARD_PLAN"
          >
            {{ billingPlan.upsellActionText }}
          </ButtonView>
        </slot>
      </div>
      <div
        v-if="showExtraInformation"
        :data-e2e="EstateCypressAttribute.standardPlan.views.EXTRA_INFORMATION"
      >
        <slot name="extra-information" />
      </div>
      <div v-if="billingPlan.needs.length" class="is-full-width is-full-height m-b-20 m-t-20">
        <div class="has-text-weight-semibold is-size-4">
          {{ $t('lightdiagnostic.clients-who') }}
        </div>
        <ul class="m-l-15">
          <li class="m-l-10" v-for="(need, index) in billingPlan.needs" :key="`need-${index}`">
            {{ need }}
          </li>
        </ul>
      </div>
      <div
        class="is-full-width has-background-tertiary-lightest has-text-tertiary has-text-centered custom-border-radius has-text-weight-bold"
        v-if="billingPlan.isRecommended"
        :data-e2e="EstateCypressAttribute.standardPlan.views.RECOMMENDED_HEADER"
      >
        {{ $t('estateupsell.recommended') }}
      </div>
      <slot name="footer" />
    </div>
  </section>
</template>

<script>
import { EstateCypressAttribute } from '/@/modules/estate/constants/EstateCypressAttribute';
import { LightDiagnosticCypressAttribute } from '@/modules/lightdiagnostic/constants/LightDiagnosticCypressAttribute';
import { SelfServeBillingPlanForm } from '@/modules/estate/models/SelfServeBillingPlanForm';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import VaultFreePlanPriceView from '@/modules/estate/components/presentational/VaultFreePlanPriceView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'VaultPlanBillingCard',
  emits: ['on-click'],
  slotsDefinition: {
    button: {},
    extraInformation: {},
    footer: {}
  },
  components: { ButtonView, VaultFreePlanPriceView },
  props: {
    billingPlan: {
      type: SelfServeBillingPlanForm,
      required: true
    },
    hasCallToAction: {
      type: Boolean,
      default: false
    },
    hidePrice: {
      type: Boolean,
      default: false
    },
    showExtraInformation: {
      type: Boolean,
      default: false
    },
    isPlanFree: {
      type: Boolean,
      defaullt: false
    }
  },
  static: {
    EstateCypressAttribute,
    LightDiagnosticCypressAttribute
  },
  computed: {
    headerClass() {
      return this.billingPlan.isRecommended ? 'has-background-secondary-dark has-text-white' : '';
    },
    recommendedTextClass() {
      return this.billingPlan.isRecommended ? 'has-text-white' : '';
    },
    buttonClass() {
      return this.billingPlan.isRecommended
        ? 'has-background-tertiary has-text-white has-border-tertiary'
        : 'has-text-primary has-border-primary';
    }
  },
  methods: {
    onClick() {
      this.$emit('on-click', this.billingPlan);
    }
  }
};
</script>

<style scoped>
@media (max-width: 1023px) {
  section.box {
    width: 100% !important;
  }
  .custom-flex {
    flex-wrap: wrap;
  }
}

section.box {
  padding: var(--ce-3px) !important;
}
.custom-border-radius {
  border-radius: var(--ce-4px);
  font-size: var(--ce-14px);
  padding: var(--ce-2px) var(--ce-0px) var(--ce-3px) var(--ce-0px);
}
li {
  list-style-type: disc;
}
.custom-flex {
  display: flex;
}
.custom-height {
  max-height: var(--ce-25px);
}

:deep(.button.is-outlined:hover) {
  background-color: var(--ce-tertiary) !important;
}
</style>
